import { ACTIONS } from './types';
import STATUS from '../../globalStatuses';
import { errorToMessage } from '../../../errorMessaging';

function wallet(
  state = {
    wallet: {
      personId: '',
      ssn: '',
      isDone: false,
      reOpt: false,
      ssnStatus: {
        getStatus: STATUS.UNFETCHED,
        modifyStatus: STATUS.UNFETCHED,
      },
    },
  },
  action,
) {
  switch (action.type) {
    // GET Ssn
    case ACTIONS.REQUEST_SSN:
      return {
        ...state,
        ssnStatus: {
          ...state.ssnStatus,
          getStatus: STATUS.FETCHING,
          errorData: null,
        },
      };
    case ACTIONS.RECEIVE_SSN:
      return {
        ...state,
        ssn: action.ssn,
        isDone: action.isDone,
        ssnStatus: {
          ...state.ssnStatus,
          getStatus: STATUS.FETCHED,
        },
      };
    case ACTIONS.REQUEST_SSN_ERROR:
      return {
        ...state,
        error: errorToMessage(action.error),
        ssnStatus: {
          ...state.ssnStatus,
          getStatus: STATUS.ERROR,
          errorData: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
        },
      };

    // POST/PUT/DELETE Ssn
    case ACTIONS.REQUEST_POST_SSN:
    case ACTIONS.REQUEST_DELETE_SSN:
    case ACTIONS.REQUEST_PUT_SSN:
      return {
        ...state,
        ssnStatus: {
          ...state.ssnStatus,
          modifyStatus: STATUS.UPDATING,
          errorData: null,
        },
      };

    case ACTIONS.RECEIVE_POST_SSN:
    case ACTIONS.RECEIVE_PUT_SSN:
      return {
        ...state,
        personId: action.personId,
        ssn: action.ssn,
        ssnStatus: {
          ...state.ssnStatus,
          modifyStatus: STATUS.UPDATED,
        },
      };
    case ACTIONS.RECEIVE_DELETE_SSN:
      return {
        ...state,
        personId: '',
        ssn: '',
        ssnStatus: {
          ...state.ssnStatus,
          modifyStatus: STATUS.UPDATED,
        },
      };

    case ACTIONS.REQUEST_POST_SSN_ERROR:
    case ACTIONS.REQUEST_PUT_SSN_ERROR:
    case ACTIONS.REQUEST_DELETE_SSN_ERROR:
      return {
        ...state,
        error: errorToMessage(action.error),
        ssnStatus: {
          ...state.ssnStatus,
          modifyStatus: STATUS.ERROR,
          errorData: action.error ? JSON.parse(JSON.stringify(action.error)) : null,
        },
      };
    case ACTIONS.CLEAR_SSN_MODIFY_STATUS:
      return {
        ...state,
        ssnStatus: {
          ...state.ssnStatus,
          modifyStatus: STATUS.UNFETCHED,
        },
      };

    // RE OPT
    case ACTIONS.RE_OPT:
      return {
        ...state,
        reOpt: action.optIn,
      };

    default:
      return state;
  }
}

export default wallet;
